
import { FlightWithVersion } from "./flightwithversion.model"; 

export class UpdateFlightsRequest {
  flights?:FlightWithVersion[];
  newMinJumps?:number;
  secret?:string;
  targetFlightId?:number;
  newJumpMaster?:number;
  newDepartureTime?:Date;
  setTookOff?:boolean;
  setStandBy?:boolean;
  setReschedule?:boolean;
}
